import React from "react";
import "./loading.scss";

const Loading = () => {
	return <div className={"loading-bar "}></div>;
};

export default Loading;
